import { SAVINGS_URL } from '@banking/ui/utils/constants';
export function generateSavingsAccountUrl(bankcBalanceId) {
  return `${SAVINGS_URL}/accounts/${bankcBalanceId}`;
}